import { useExportCustomers } from '../services';
import { downloadCustomersExcel } from '../utils/export-customers.util';

type AlertFn = (alert: { open: boolean; message: string; msgType: string }) => void;

export const useExportCustomersExcel = (onAlert: AlertFn) => {
  const { mutate, isPending } = useExportCustomers();

  const exportToExcel = (restaurantId: string, restaurantName: string) => {
    mutate(restaurantId, {
      onSuccess: (customers) => {
        if (!customers || customers.length === 0) {
          onAlert({ open: true, message: 'No customers to export', msgType: 'warning' });
          return;
        }
        const result = downloadCustomersExcel(customers, restaurantName);
        if (!result.ok) {
          console.error('Export file generation error:', result.error);
          onAlert({ open: true, message: 'Failed to generate export file', msgType: 'error' });
          return;
        }
        onAlert({ open: true, message: 'Customers exported successfully', msgType: 'success' });
      },
      onError: (error) => {
        console.error('Export error:', error);
        onAlert({ open: true, message: 'Failed to export customers', msgType: 'error' });
      },
    });
  };

  return { exportToExcel, isPending };
};
